<template>
  <div class="m-main-coin">
    <h3>主代币</h3>
    <div class="infos table-shadow">
      <div class="line flex-left">
        <img src="../../../assets/img/tip/red.png" alt />
        <label>代币</label>
        <!-- <router-link class="link" to="/mainHolder">{{symbol}}</router-link> -->
        <span>{{symbol}}</span>
        <img :src="baseCoin" class="logo" />
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/blue.png" alt />
        <label>时间</label>
        <span>2018-05-17</span>
      </div>
      <div class="line flex-left">
        <img src="../../../assets/img/tip/pink.png" alt />
        <label>持有人</label>
        <!-- <span>{{holders|filterNum}}</span> -->
        <router-link class="link" to="/mainHolder">{{holders|filterNum}}</router-link>
      </div>
      <div class="line flex-left ind">
        <img src="../../../assets/img/tip/green.png" alt />
        <label>简介</label>
        <div class="introduce">
          <pre>
比特元，一种简单稳定、扩展性强的区块链网络。 国内第一个提出平行链，国内第一个区块链发明专利：钱包找回功能。
结合比特币、比特股、以太坊技术进行创新，秉承着简单稳定的原则，从而实现安全快速支付、隐私交易和原子互换、一键Token等功能，同时运用离线钱包和钱包找回等功能来保障比特元数字资产的安全性。
    比特元平行链有独立钱包、自我区块链生态等，而安全共识则由主链提供，提升整体生态的多样性。
          </pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainCoin from "@/mixins/Token/mainCoin";
export default {
  mixins: [mainCoin]
};
</script>

<style lang="scss" scoped>
.m-main-coin {
  padding: 10px 0 17px;
  h3 {
    color: $black;
    font-size: 14px;
    font-family: PingFangSC-Semibold;
  }
  .infos {
    margin-top: 10px;
    padding: 10px;
    background: $white;
    border-radius: 2px;
    border: 1px solid rgba(235, 239, 241, 1);
    color: $black;
    font-size: 12px;
    .line {
      min-height: 35px;
      vertical-align: top;
      .link {
        color: $blue;
      }
    }
    .ind {
      padding-top: 5px;
    }
    label {
      min-width: 60px;
      padding-left: 9px;
    }
    .logo {
      height: 20px;
      margin-left: 10px;
    }
    .introduce {
      vertical-align: top;
      display: inline-block;
      text-indent: 2em;
      width: 230px;
      pre {
        white-space: pre-wrap;
        line-height: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>